module.exports = __webpack_public_path__ + "img/rb-profile.57d82d90.jpeg";